export default [
  // user
  {
    title: 'requestsearch',
    route: 'requestsearch',
    icon: 'HomeIcon',
    role: ['USER'],
  },
  // approver
  {
    title: 'requestsearch',
    route: 'requestsearch',
    icon: 'HomeIcon',
    role: ['APPROVER'],
  },
  // All User and Approver
  // worker
  {
    title: 'updatesearch',
    route: 'updatesearch',
    icon: 'HomeIcon',
    role: ['WORKER'],
  },

  // admin and super admin
  {
    title: 'adminsearch',
    route: 'adminsearch',
    icon: 'HomeIcon',
    role: ['SYSTEM', 'ADMIN'],
  },
  /* admin superadmin and worker */

  {
    title: 'usersearch',
    route: 'usersearch',
    icon: 'UserIcon',
    role: ['SYSTEM', 'ADMIN'],
  },

  {
    title: 'dashboard',
    route: 'dashboard',
    icon: 'PieChartIcon',
    role: ['SYSTEM', 'ADMIN'],
  },

  {
    title: 'settings',
    route: 'settings',
    icon: 'SettingsIcon',
    role: ['SYSTEM', 'ADMIN'],
    children: [
      {
        title: 'userform',
        route: 'userform',
        icon: 'UserPlusIcon',
        role: ['SYSTEM', 'ADMIN'],
      },
      {
        title: 'departmentform',
        route: 'departmentform',
        icon: 'AlignLeftIcon',
        role: ['SYSTEM', 'ADMIN'],
      },
      {
        title: 'CategoryManagement',
        route: 'CategoryManagement',
        icon: 'AlertTriangleIcon',
        role: ['SYSTEM', 'ADMIN'],
      },
      {
        title: 'Expense',
        route: 'Expense',
        icon: 'DollarSignIcon',
        role: ['SYSTEM', 'ADMIN'],
      },
      {
        title: 'location',
        route: 'location',
        icon: 'GlobeIcon',
        role: ['SYSTEM', 'ADMIN'],
      },
      {
        title: 'jobtitleEdit',
        route: 'jobtitle',
        icon: 'CheckSquareIcon',
        role: ['SYSTEM', 'ADMIN'],
      },
    ],
  },
  {
    title: 'resetpassword',
    route: 'resetpassword',
    icon: 'KeyIcon',
  },
]
